import React from 'react'

const VerticalLine = () => <div className="h-[30px] w-[1px] bg-white opacity-20" />

export default VerticalLine
